import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type IMarkupFieldsFragment = {
  id?: any | null
  projectId: any
  sitePermitId?: any | null
  globeViewId?: any | null
  kind?: string | null
  geometryType?: string | null
  color?: string | null
  strokeWidth?: number | null
  opacity?: number | null
  fillColor?: string | null
  text?: string | null
  strokeStyle?: string | null
  fillStyle?: string | null
  shapeKind?: string | null
  lineType?: string | null
  arrowheadStart?: string | null
  arrowheadEnd?: string | null
  fontSize?: number | null
  bold?: boolean | null
  italic?: boolean | null
  underline?: boolean | null
  textAlign?: string | null
  boxWidth?: number | null
  rotation?: number | null
  isDeleted?: boolean | null
  createdAt?: any | null
  updatedAt?: any | null
  coordinates?: Array<{ latitude: number; longitude: number } | null> | null
}

export type IMarkupsByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
  sitePermitIds?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.Scalars['ObjectId']['input']>>
    | Types.InputMaybe<Types.Scalars['ObjectId']['input']>
  >
}>

export type IMarkupsByProjectIdQuery = {
  markups?: {
    data: Array<{
      id?: any | null
      projectId: any
      sitePermitId?: any | null
      globeViewId?: any | null
      kind?: string | null
      geometryType?: string | null
      color?: string | null
      strokeWidth?: number | null
      opacity?: number | null
      fillColor?: string | null
      text?: string | null
      strokeStyle?: string | null
      fillStyle?: string | null
      shapeKind?: string | null
      lineType?: string | null
      arrowheadStart?: string | null
      arrowheadEnd?: string | null
      fontSize?: number | null
      bold?: boolean | null
      italic?: boolean | null
      underline?: boolean | null
      textAlign?: string | null
      boxWidth?: number | null
      rotation?: number | null
      isDeleted?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      coordinates?: Array<{ latitude: number; longitude: number } | null> | null
    }>
  } | null
}

export type ISaveMarkupMutationVariables = Types.Exact<{
  markup: Types.IMarkupInput
}>

export type ISaveMarkupMutation = { saveMarkup?: { id?: any | null } | null }

export type IDeleteMarkupMutationVariables = Types.Exact<{
  id: Types.Scalars['ObjectId']['input']
}>

export type IDeleteMarkupMutation = { deleteMarkup?: boolean | null }

export type IListenMarkupsByProjectIdSubscriptionVariables = Types.Exact<{
  projectId: Types.Scalars['ObjectId']['input']
}>

export type IListenMarkupsByProjectIdSubscription = {
  markup?: {
    id?: any | null
    item?: {
      id?: any | null
      projectId: any
      sitePermitId?: any | null
      globeViewId?: any | null
      kind?: string | null
      geometryType?: string | null
      color?: string | null
      strokeWidth?: number | null
      opacity?: number | null
      fillColor?: string | null
      text?: string | null
      strokeStyle?: string | null
      fillStyle?: string | null
      shapeKind?: string | null
      lineType?: string | null
      arrowheadStart?: string | null
      arrowheadEnd?: string | null
      fontSize?: number | null
      bold?: boolean | null
      italic?: boolean | null
      underline?: boolean | null
      textAlign?: string | null
      boxWidth?: number | null
      rotation?: number | null
      isDeleted?: boolean | null
      createdAt?: any | null
      updatedAt?: any | null
      coordinates?: Array<{ latitude: number; longitude: number } | null> | null
    } | null
  } | null
}

export const MarkupFieldsFragmentDoc = gql`
  fragment MarkupFields on Markup {
    id
    projectId
    sitePermitId
    globeViewId
    kind
    geometryType
    coordinates {
      latitude
      longitude
    }
    color
    strokeWidth
    opacity
    fillColor
    text
    strokeStyle
    fillStyle
    shapeKind
    lineType
    arrowheadStart
    arrowheadEnd
    fontSize
    bold
    italic
    underline
    textAlign
    boxWidth
    rotation
    isDeleted
    createdAt
    updatedAt
  }
`
export const MarkupsByProjectIdDocument = gql`
  query MarkupsByProjectId($projectId: ObjectId!, $sitePermitIds: [ObjectId]) {
    markups(
      projectId: $projectId
      sitePermitIds: $sitePermitIds
      limit: 1000000
    ) {
      data {
        ...MarkupFields
      }
    }
  }
  ${MarkupFieldsFragmentDoc}
`

/**
 * __useMarkupsByProjectIdQuery__
 *
 * To run a query within a React component, call `useMarkupsByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarkupsByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarkupsByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sitePermitIds: // value for 'sitePermitIds'
 *   },
 * });
 */
export function useMarkupsByProjectIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IMarkupsByProjectIdQuery,
    IMarkupsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IMarkupsByProjectIdQuery,
    IMarkupsByProjectIdQueryVariables
  >(MarkupsByProjectIdDocument, options)
}
export function useMarkupsByProjectIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IMarkupsByProjectIdQuery,
    IMarkupsByProjectIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IMarkupsByProjectIdQuery,
    IMarkupsByProjectIdQueryVariables
  >(MarkupsByProjectIdDocument, options)
}
export type MarkupsByProjectIdQueryHookResult = ReturnType<
  typeof useMarkupsByProjectIdQuery
>
export type MarkupsByProjectIdLazyQueryHookResult = ReturnType<
  typeof useMarkupsByProjectIdLazyQuery
>
export type MarkupsByProjectIdQueryResult = Apollo.QueryResult<
  IMarkupsByProjectIdQuery,
  IMarkupsByProjectIdQueryVariables
>
export const SaveMarkupDocument = gql`
  mutation SaveMarkup($markup: MarkupInput!) {
    saveMarkup(markup: $markup) {
      id
    }
  }
`
export type ISaveMarkupMutationFn = Apollo.MutationFunction<
  ISaveMarkupMutation,
  ISaveMarkupMutationVariables
>

/**
 * __useSaveMarkupMutation__
 *
 * To run a mutation, you first call `useSaveMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMarkupMutation, { data, loading, error }] = useSaveMarkupMutation({
 *   variables: {
 *      markup: // value for 'markup'
 *   },
 * });
 */
export function useSaveMarkupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveMarkupMutation,
    ISaveMarkupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISaveMarkupMutation, ISaveMarkupMutationVariables>(
    SaveMarkupDocument,
    options,
  )
}
export type SaveMarkupMutationHookResult = ReturnType<
  typeof useSaveMarkupMutation
>
export type SaveMarkupMutationResult =
  Apollo.MutationResult<ISaveMarkupMutation>
export type SaveMarkupMutationOptions = Apollo.BaseMutationOptions<
  ISaveMarkupMutation,
  ISaveMarkupMutationVariables
>
export const DeleteMarkupDocument = gql`
  mutation DeleteMarkup($id: ObjectId!) {
    deleteMarkup(id: $id)
  }
`
export type IDeleteMarkupMutationFn = Apollo.MutationFunction<
  IDeleteMarkupMutation,
  IDeleteMarkupMutationVariables
>

/**
 * __useDeleteMarkupMutation__
 *
 * To run a mutation, you first call `useDeleteMarkupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMarkupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMarkupMutation, { data, loading, error }] = useDeleteMarkupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMarkupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteMarkupMutation,
    IDeleteMarkupMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteMarkupMutation,
    IDeleteMarkupMutationVariables
  >(DeleteMarkupDocument, options)
}
export type DeleteMarkupMutationHookResult = ReturnType<
  typeof useDeleteMarkupMutation
>
export type DeleteMarkupMutationResult =
  Apollo.MutationResult<IDeleteMarkupMutation>
export type DeleteMarkupMutationOptions = Apollo.BaseMutationOptions<
  IDeleteMarkupMutation,
  IDeleteMarkupMutationVariables
>
export const ListenMarkupsByProjectIdDocument = gql`
  subscription ListenMarkupsByProjectId($projectId: ObjectId!) {
    markup(projectId: $projectId) {
      id
      item {
        ...MarkupFields
      }
    }
  }
  ${MarkupFieldsFragmentDoc}
`

/**
 * __useListenMarkupsByProjectIdSubscription__
 *
 * To run a query within a React component, call `useListenMarkupsByProjectIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenMarkupsByProjectIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenMarkupsByProjectIdSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useListenMarkupsByProjectIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenMarkupsByProjectIdSubscription,
    IListenMarkupsByProjectIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenMarkupsByProjectIdSubscription,
    IListenMarkupsByProjectIdSubscriptionVariables
  >(ListenMarkupsByProjectIdDocument, options)
}
export type ListenMarkupsByProjectIdSubscriptionHookResult = ReturnType<
  typeof useListenMarkupsByProjectIdSubscription
>
export type ListenMarkupsByProjectIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenMarkupsByProjectIdSubscription>
